export const inputsState = {
  diversityLeadership: [],
  diversityOwned: [],
  diversityPreferNotDeclare: false,
  selfDeclaration: false,
};
